module.exports = __webpack_public_path__ + "i18n/nl.84594be54be4fb3f7b5fad0479fb86ae.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1062
// module chunks = 60